/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    PHASE_6_BROADCAST_DELETED_PAGE
 * Date:         2026-01-28
 * Modified By:  Cursor
 *
 * Description:
 * Phase 6: Deleted broadcast page showing "no longer available" message with similar items (BR-19).
 *
 * File Size Check:
 * - Current: 0 lines (new file)
 * - Projected: ~100 lines
 * - Decision: Proceed (within 200 line limit)
 *
 * Related Files:
 * - client/src/pages/Broadcast/BroadcastResponse.tsx
 * - server/middlewares/responseAuth.js
 */

// [2026-02-07] style-extraction: moved inline styles to SCSS module
import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Container, Alert, Button, ListGroup } from "react-bootstrap";
import styles from "./Broadcast.module.scss";

interface Suggestion {
  id: string;
  title: string;
  category: string;
}

function BroadcastDeleted() {
  useParams<{ id: string }>(); // route param for /broadcast/deleted/:id; not used in UI
  const navigate = useNavigate();
  const location = useLocation();
  const suggestions: Suggestion[] = location.state?.suggestions || [];

  return (
    <Container className={`mt-5 ${styles.narrowContainer}`}>
      <Alert variant="warning" className="mb-4">
        <Alert.Heading>This broadcast is no longer available</Alert.Heading>
        <p className="mb-0">
          The seller has removed this listing. It may have been sold, withdrawn, or
          is no longer available.
        </p>
      </Alert>

      <div className="mb-4">
        <Button variant="primary" onClick={() => navigate("/")}>
          Go to Dashboard
        </Button>
      </div>

      {suggestions.length > 0 && (
        <div className="mt-5">
          <h4>Similar items in this category:</h4>
          <ListGroup>
            {suggestions.map((item) => (
              <ListGroup.Item
                key={item.id}
                action
                onClick={() => navigate(`/allbroadcasts/details/${item.id}`)}
                className={styles.clickableItem}
              >
                <div>
                  <strong>{item.title}</strong>
                  {item.category && (
                    <span className="text-muted ms-2">({item.category})</span>
                  )}
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      )}
    </Container>
  );
}

export default BroadcastDeleted;
